<template lang="pug">
  .gvl-funding
    h2 Stipendienprogramm der Verwertungsgesellschaften in NEUSTART KULTUR

    .notice-box Das Antragsportal wurde vorzeitig geschlossen, da die Mittel aufgrund der Anzahl an Anträgen bereits ausgeschöpft sind.

    h3.mt-4 Stipendienprogramm
    p
      | Im Rahmen des von der Beauftragten der Bundesregierung für Kultur und Medien initiierten
      | Stipendienprogramms der Verwertungsgesellschaften in NEUSTART KULTUR schreibt die
      | Gesellschaft zur Verwertung von Leistungsschutzrechten mbH (GVL) ein Stipendienprogramm 2021 aus.
    p
      | Durch die COVID-19-Pandemie sind wesentliche Vertriebswege, Vermittlungsplattformen und
      | Kommunikationsorte im Kulturbereich weggebrochen. Veranstaltungsorte wie Konzerthallen oder
      | Theater befinden sich seit über einem Jahr im Ausnahmezustand; Musik-, Fernseh- und
      | Filmproduktionen konnten nur stark eingeschränkt stattfinden, mussten in die Zukunft verlegt oder in
      | den digitalen Raum verschoben werden. Neue Produktionen können nicht im Kino gezeigt werden.
      | Vor diesem Hintergrund müssen viele ausübende Künstler*
      | 1 signifikante Einnahmeausfälle erleiden.
      | Gleichzeitig bieten die Umstände aber auch eine Chance, die Bedeutung der eigenen künstlerischen
      | Arbeit zu reflektieren und neue Formen der Produktion, Aufführung und Vermittlung zu entwickeln.
      | Kreatives Potenzial bieten in dieser Situation nicht zuletzt auch Überlegungen zu alternativen, auch
      | digitalen Formaten.

    h3 Fördergegenstand
    ul
      li
        | Das Stipendienprogramm der Verwertungsgesellschaften in NEUSTART KULTUR zielt darauf
        | ab freiberufliche oder auf Produktionsdauer beschäftigte ausübende Künstler* dabei zu
        | unterstützen, ihre Arbeit trotz Einschränkungen durch die COVID-19-Pandemie fortsetzen zu
        | können. Die Stipendien sollen Künstlern* ermöglichen, Ideen in der Zeit während und nach
        | der durch die Corona-Pandemie bedingten Einschränkungen zu entwickeln. Das können
        | beispielsweise Recherchearbeiten sein, Weiterbildungen im Beruf des ausübenden Künstlers,
        | Konzepte sowohl im digitalen als auch im öffentlichen Raum sowie die Produktion von
        | medialen Inhalten. Grundsätzlich werden keine Auslands- oder Wissenschaftsstipendien
        | gefördert.
      li Das Stipendienprogramm umfasst Stipendien in Höhe von EUR 5.000,00 pro Person für eine Stipendiendauer von vier Monaten.

    h3 Ziele der Förderung
    p.mb-0 Mit dem Stipendienprogramm sollen folgende Ziele erreicht werden:
    table
      tr
        th: h4 Ziele des Programms
        th: h4 Förderinhalte
        th: h4 Mögliche Nachweisdokumente
      tr
        td
          | Ziel des Programms ist, das Aufrechterhalten der professionellen Fertigkeiten von Kreativen auch jenseits der Öffentlichkeit zu ermöglichen,
          | z. B. durch Recherchieren, Üben, Proben, Trainieren oder der Entwicklung neuer kreativer Ansätze, bis die Öffentlichkeit
          | wieder durch Projekte, Veranstaltungen oder Engagements einbezogen werden kann.
        td
          | Maßnahmen, wie z.B. die Entwicklung und Umsetzung von Online-Formaten, interaktiven Projekten, OnlineKooperationen, die die
          | künstlerische Darbietung zum Gegenstand haben, Rechercheprojekte für künftige Produktionen mit künstlerischen Darbietungen,
          | Projekte mit künstlerischen Darbietungen, die mit Unterstützung des Stipendiums realisiert werden sollen.
        td
          | Nachweis von Online-Formaten der künstlerischen Darbietungen (URLs, Veröffentlichungsdatum), Projekt- und Rechercheberichte bzw.
          | Konzepte (im PDF-Format).
      tr
        td
          | Kulturschaffende sollen befähigt werden, die aktuelle Situation kreativ für ihre künstlerische Weiterentwicklung zu nutzen, insbesondere die Erarbeitung
          | zukunftsweisender Konzepte und sinnstiftender Formate sowie im Hinblick auf Nachhaltigkeit und zum Weiterdenken bestehender Strukturen (Überbrückung).
          | Mithilfe des Stipendiums soll der hierfür notwendige materielle Rahmen geschaffen werden.
        td
          | Maßnahmen, wie z.B. die Aneignung und Erprobung neuer Techniken und Arbeitsweisen, Fortbildungsmaßnahmen für künstlerische Darbietungen.
        td
          | Rechnung der Weiterbildungsmaßnahme, Aus- und Weiterbildungszertifikate, Angaben zu Dauer und Inhalten der Aus- und Weiterbildungsmaßnahme.

    p.mt-2
      | Der Antragsteller* nimmt für das bei der GVL beantragte Projekt innerhalb des viermonatigen Förderzeitraums kein anderes Stipendium oder Förderprogramm des Bundes, der Länder oder der
      | Kommunen in Anspruch. Über das Sonderförderprogramm kann pro Person maximal ein Stipendium vergeben werden.
    p
      | Die Stipendien dienen anderen Zwecken als der Sicherung des Lebensunterhalts Sie sind deshalb
      | nicht unmittelbar als Einkommen (eigener Art neben dem Einkommen aus selbständiger
      | Erwerbstätigkeit) in der Grundsicherung für Arbeitssuchende (Arbeitslosengeld II) zu berücksichtigen.

    h3 Zuwendungsempfänger
    p Antragsberechtigt sind natürliche Personen mit Hauptwohnsitz in Deutschland.
    p
      | Das Förderprogramm richtet sich an professionell freiberuflich oder auf Produktionsdauer beschäftigte ausübende Künstler* die ihre
      | künstlerische Tätigkeit im Haupterwerb betreiben. Der Nachweis erfolgt grundsätzlich über die Mitgliedschaft in der Künstlersozialkasse.
    p
      | Zusätzlich ist ein Nachweis über die Mitgliedschaft in der GVL zu erbringen. Der
      | Wahrnehmungsvertrag muss zum Zeitpunkt des Abschlusses des Fördervertrags vorliegen; ein
      | Antrag auf Abschluss eines Wahrnehmungsvertrags mit der GVL kann bis zum Ende der
      | Ausschreibungsphase gestellt werden. Antragsteller*, die ihre Eigenschaft als ausübender Künstler*
      | hinreichend belegen, können auch ohne Wahrnehmungsvertrag gefördert werden.
    p
      | Künstler* ohne KSK-Mitgliedschaft weisen ihre Eigenschaft als ausübender Künstler* durch aussagekräftige Dokumente nach (siehe unten).
    p
      | Berufsanfänger* ohne KSK-Mitgliedschaft weisen ein Abschlusszeugnis oder Diplom einer künstlerischen Ausbildung nach (siehe unten).
    p
      | Der Antragsteller* darf im Jahr 2020 maximal Einkünfte in Höhe von EUR 60.000,00 erzielt haben,
      | unabhängig von der Art der Einkünfte. Bei Antragstellung ist der ESt-Bescheid 2020 einzureichen.
      | Sollte der ESt-Bescheid 2020 noch nicht vorliegen, reicht der Antragsteller* hilfsweise den EStBescheid 2019 und versichert zusätzlich, dass der Gesamtbetrag der Einkünfte im Jahr 2020 den
      | Wert von EUR 60.000,00 nicht übersteigt.
    p Nicht antragsberechtigt sind Juroren des vorliegenden Programms.
    p Der Antragsteller* verfügt über ein eigenes Girokonto mit einer IBAN-Nummer und über eine eigene E-Mail-Adresse.
    p Der Antragsteller* willigt in die Erklärung zur Datenverarbeitung und Datenverwendung ein.
    p
      | Der Antragssteller* füllt die Pflichtfelder des elektronischen Förderantrags vollständig aus, lädt die
      | einzureichenden Dokumente vollständig elektronisch hoch und sendet den Antrag auf dem vorgesehenen elektronischen Weg an die GVL.

    h3 Verfahren
    p
      | Nach Erhalt des Zuwendungsbescheids vom Bundesverwaltungsamt (BVA) erfolgt eine offizielle zweiwöchige Bekanntmachung des Stipendienprogramms der Verwertungsgesellschaften in NEUSTART
      | KULTUR auf der Website der GVL www.gvl.de. Nach Ablauf dieser zwei Wochen beginnt die sechswöchige Bewerbungsphase.
    p Die Bewerbungsphase kann vorzeitig beendet werden, sobald genügend Anträge eingegangen sind, dass eine Auskehrung der maximalen Anzahl an Stipendien sichergestellt ist.
    p Für den Fall, dass innerhalb des Bewerbungszeitraums der vollständige Förderbetrag nicht ausgeschöpft wurde, kann eine weitere Bewerbungsrunde à sechs Wochen eröffnet werden kann.
    p
      | Die Anträge werden entsprechend der Reihenfolge ihres Eingangs bearbeitet. Anträge gelten erst dann als formal ordnungsgemäß gestellt,
      | wenn sämtliche antragsbegründende Unterlagen zur Prüfung vorliegen.
    p
      | Die GVL benennt mindestens eine dreiköpfige unabhängige Jury. Diese setzt sich zusammen aus
      | zwei Vertretern der ausübenden Künstler* und möglichst einem Mitarbeiter* der GVL, wobei eine
      | Gender-paritätische Besetzung angestrebt wird. Jeder formal korrekt eingereichte und vollständige
      | Förderantrag, der die Antragsfrist eingehalten hat, wird von einer Jury begutachtet. Über das
      | Verfahren und die Kriterien der Jurierung entscheidet die GVL.
    p
      | Es besteht kein Rechtsanspruch auf Förderung. Die Entscheidung über eine Förderung
      | trifft allein die zuständige Jury. Nach abgeschlossener Prüfung erhält der Antragsteller* eine
      | Information per E-Mail über die Bewilligung oder Ablehnung des Antrages. Im Falle eines positiven
      | Juryentscheids erhält der Antragssteller* einen Fördervertrag, welcher der GVL innerhalb von zwei
      | Wochen nach Erhalt unterzeichnet vorliegen muss. Andernfalls verfällt die positive Juryentscheidung.
    p.mb-1 Dem Antrag sind folgende Unterlagen beizufügen:
    ul
      li Darstellung des konzeptionellen Vorhabens, das im Rahmen des Stipendiums umgesetzt werden soll (max. 2.000 Zeichen)
      li künstlerische Vita (max. 800 Zeichen)
      li Auflistung von durchgeführten Konzerten / Aufführungen / Produktionen in den Jahren 2019 und 2020
      li
        | ESt-Bescheid 2020; sollte der ESt-Bescheid 2020 noch nicht vorliegen, übermittelt der Antragsteller* hilfsweise den ESt-Bescheid 2019 und versichert, dass der
        | Gesamtbetrag der Einkünfte im Jahr 2020 den Betrag von EUR 60.000,00 nicht übersteigt.
      li Nachweis über die Mitgliedschaft in der Künstlersozialkasse (KSK)
      li betrifft nur Antragsteller ohne KSK-Mitgliedschaft:
        ul
          li.mt-1 aktueller Nachweis über die ausgeübte künstlerische Selbständigkeit gem. § 18 EstG oder
          li.mt-1 Sozialversicherungsnachweis, dessen Tätigkeitsschlüssel mit 94 (darstellende Berufe) beginnt lt. Klassifizierung der Berufe 2010 o.ä.
      li betrifft nur Berufsanfänger ohne KSK-Mitgliedschaft:
        ul
          li.mt-1 Abschlusszeugnis einer künstlerischen Ausbildung oder
          li.mt-1 Diplom künstlerisches Studium
          li.mt-1 alternativ: Verträge, Honorarabrechnungen über Engagements
      li Nachweis über den Hauptwohnsitz (Kopie des Personalausweises Vorder- + Rückseite, alternativ Reisepass + Meldebescheinigung).

    p
      | Die Antragsberatung, Prüfung, Gewährung und Auszahlung der Fördermittel erfolgen durch die GVL.
      | Die Stipendien werden als einmalige, nicht rückzahlbare Zuwendung analog der §§ 23, 44 der
      | Bundeshaushaltsordnung einschließlich der hierzu erlassenen Verwaltungsvorschriften im Wege
      | eines privatrechtlichen Fördervertrages gewährt. Für die ggf. erforderliche Aufhebung und die
      | Rückforderung der gewährten Förderung gelten analog die §§ 48 bis 49a des Verwaltungsverfahrensgesetzes (VwVfG).
    p
      | Nach Eingang des unterzeichneten Fördervertrags überweist die GVL dem Antragssteller* in 90% der
      | Fördersumme (EUR 4.500,00) auf das im Förderantrag angegebene Girokonto.
    p
      | Die Dauer des Stipendiums beträgt vier Monate. Das Stipendium beginnt mit dem
      | Überweisungsdatum des Förderbetrags und endet vier Monate später. Innerhalb des letzten (vierten)
      | Monats ist ein Sachbericht (mindestens 1.000 Zeichen und maximal 5.000 Zeichen) des Stipendiaten
      | einzureichen, aus dem hervorgeht, wie das beantragte Projekt umgesetzt wurde. Nach Eingang des
      | Sachberichts wird nach positiver Prüfung die zweite Tranche in Höhe von EUR 500,00 ausgezahlt.
    p
      | Unrichtige Angaben bzw. unrichtige Nachweise bei der Antragsstellung und/oder eine Verletzung der
      | im Fördervertrag festgelegten Pflichten können zu Rückforderungen der Stipendiengelder führen.

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
})
export default class Funding extends Vue {

}
</script>

<style lang="sass">
.gvl-funding
  p
    margin-bottom: 0

  h3 + p,
  h3 + ul
    margin-top: 10px

  p + p,
  ul + p,
  li + li
    margin-top: 8px

  p + h3,
  ul + h3
    margin-top: 16px

  table
    border-collapse: collapse

    th
      text-align: left

    td, th
      padding: 10px
      border: 1px solid #000
      vertical-align: top
</style>
